module.exports = __webpack_public_path__ + "static/media/kidmania.b1d65d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/kidmania.png
// module id = 473
// module chunks = 0